import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useDispatch } from "react-redux";
import { updateApplications } from "../../../../state/slices/application";
import { useUpdateApplicationMutation } from "../../../../state/services/applications";

const divStyle = {
  fontSize: "inherit",
  lineHeight: "inherit",
  color: "inherit",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "inherit",
  borderRadius: "0",
  boxShadow: "none",
  backgroundColor: "inherit",
  margin: "0",
  padding: "0",
  width: "100%",
  height: "100%",
  overflow: "visible",
};

const inputStyle = {
  borderStyle: "solid",
  borderColor: "inherit",
  borderWidth: "0",
  borderRadius: "0",
  margin: "0",
  padding: "1px 4px 1px 4px",
  width: "100%",
  height: "100%",
  position: "absolute",
  top: "0px",
  boxSizing: "border-box",
  "--focus-outline": "0",
};

const KEY_BACKSPACE = 8;
const KEY_DELETE = 46;
const KEY_LEFT = 37;
const KEY_RIGHT = 39;

const isLeftOrRight = (event) => {
  return [KEY_LEFT, KEY_RIGHT].indexOf(event.keyCode) > -1;
};

const deleteOrBackspace = (event) => {
  return [KEY_DELETE, KEY_BACKSPACE].indexOf(event.keyCode) > -1;
};

// This component will be rendered when a number cell is double clicked on so the user can edit
// the value. It also takes care of saving the edits by dispatching actions (redux store).
const NumberCellEditor = forwardRef((props, ref) => {
  const { min, max, step } = props;
  const [row] = useState(props.data);
  const [col] = useState(props.column.colId);
  const [value, setValue] = useState(
    props.keyPress === KEY_BACKSPACE || props.keyPress === KEY_DELETE
      ? ""
      : props.value
  );
  const refInput = useRef(null);
  const dispatch = useDispatch();

  const [updateApplication] = useUpdateApplicationMutation();

  useEffect(() => {
    // focus on the input
    setTimeout(() => refInput.current.focus());
  }, []);

  const onKeyDown = (event) => {
    if (isLeftOrRight(event) || deleteOrBackspace(event)) {
      event.stopPropagation();
    }
  };

  /* Component Editor Lifecycle methods */
  useImperativeHandle(ref, () => {
    return {
      // the final value to send to the grid, on completion of editing
      getValue() {
        return value;
      },

      // Gets called once before editing starts, to give editor a chance to
      // cancel the editing before it even starts.
      isCancelBeforeStart() {
        return false;
      },

      // Gets called once when editing is finished (eg if Enter is pressed).
      // If you return true, then the result of the edit will be ignored.
      isCancelAfterEnd() {
        const newData = { ...row, [col]: value };
        updateApplication(newData);
        dispatch(updateApplications(newData));
        return true; // stop Ag-Grid from modifying the immutable data!
      },

      isPopup() {
        return false;
      },
    };
  });

  return (
    <div style={divStyle}>
      <input
        type={"number"}
        min={min}
        max={max}
        step={step}
        style={inputStyle}
        ref={refInput}
        value={value}
        onKeyDown={onKeyDown}
        onChange={(event) => setValue(event.target.value)}
      />
    </div>
  );
});

export default NumberCellEditor;
